/* Kerzen Pfeilstetter — Händlerkarte (sections/store-locator.liquid)
   Lädt die freigegebenen Händler aus dem B2B-Backend, sortiert sie nach
   Entfernung (PLZ-Suche oder Browser-Standort) und zeigt sie als Liste.
   Die Karte (Leaflet aus den Theme-Assets) lädt erst nach Zustimmung.

   Sicherheit: Die Daten pflegen Händler selbst → ausschließlich über
   textContent/Attribute ins DOM, nie als HTML. */
(function () {
  'use strict';

  var CONSENT_KEY = 'kp:store-map-consent';
  /** Nach einer Suche zeigt die Karte den Suchpunkt + Händler in diesem Umkreis. */
  var NEARBY_KM = 50;
  var NEARBY_MAX = 8;
  /** Zoomstufe rund um den Suchpunkt, wenn im Umkreis kein Händler liegt (~20 km). */
  var ORIGIN_ZOOM = 11;
  var WEEKDAYS = ['mo', 'tu', 'we', 'th', 'fr', 'sa', 'su'];
  var JS_DAY_TO_KEY = { Mon: 'mo', Tue: 'tu', Wed: 'we', Thu: 'th', Fri: 'fr', Sat: 'sa', Sun: 'su' };

  function readConsent() {
    try { return window.localStorage.getItem(CONSENT_KEY) === '1'; } catch (e) { return false; }
  }
  function storeConsent() {
    try { window.localStorage.setItem(CONSENT_KEY, '1'); } catch (e) { /* privat/gesperrt */ }
  }

  function fill(template, values) {
    return String(template).replace(/\[(\w+)\]/g, function (m, key) {
      return values[key] != null ? values[key] : m;
    });
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function safeUrl(url) {
    return typeof url === 'string' && /^https?:\/\//i.test(url) ? url : null;
  }

  /** Luftlinie in km (Haversine). */
  function distanceKm(a, b) {
    var rad = Math.PI / 180;
    var dLat = (b.lat - a.lat) * rad;
    var dLng = (b.lng - a.lng) * rad;
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(a.lat * rad) * Math.cos(b.lat * rad) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 12742 * Math.asin(Math.sqrt(h));
  }

  /** Wochentag + Uhrzeit in deutscher Zeit — unabhängig von der Zeitzone des Geräts. */
  function nowInGermany() {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Berlin', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date());
    var get = function (type) {
      var p = parts.filter(function (x) { return x.type === type; })[0];
      return p ? p.value : '';
    };
    return { day: JS_DAY_TO_KEY[get('weekday')] || 'mo', time: get('hour') + ':' + get('minute') };
  }

  function formatIntervals(intervals, t) {
    if (!intervals || !intervals.length) return t.closed;
    return intervals.map(function (i) { return i.open + '–' + i.close; }).join(', ');
  }

  /** Status-Zeile für heute: geöffnet / öffnet um / geschlossen. */
  function todayStatus(hours, now, t) {
    var today = (hours && hours[now.day]) || [];
    if (!today.length) return { open: false, text: t.closed_today };
    for (var i = 0; i < today.length; i++) {
      if (now.time >= today[i].open && now.time < today[i].close) {
        return { open: true, text: fill(t.open_now, { time: today[i].close }) };
      }
      if (now.time < today[i].open) {
        return { open: false, text: fill(t.opens_today, { time: today[i].open }) };
      }
    }
    return { open: false, text: t.closed_now };
  }

  function StoreLocator(root) {
    this.root = root;
    this.apiBase = (root.getAttribute('data-api-base') || '').replace(/\/+$/, '');
    this.t = JSON.parse(root.querySelector('[data-store-locator-i18n]').textContent);
    this.list = root.querySelector('[data-store-locator-list]');
    this.status = root.querySelector('[data-store-locator-status]');
    this.resetBtn = root.querySelector('[data-store-locator-reset]');
    this.queryInput = root.querySelector('[data-store-locator-query]');
    this.stores = [];
    this.origin = null; // { lat, lng, label }
    this.textFilter = '';
    this.map = null;
    this.markers = {};
    this.activeId = null;
    this.bind();
    this.load();
    if (readConsent()) this.loadMap();
  }

  StoreLocator.prototype.bind = function () {
    var self = this;
    this.root.querySelector('[data-store-locator-form]').addEventListener('submit', function (e) {
      e.preventDefault();
      self.search(self.queryInput.value.trim());
    });
    this.root.querySelector('[data-store-locator-locate]').addEventListener('click', function () {
      self.locate();
    });
    this.root.querySelector('[data-store-locator-load-map]').addEventListener('click', function () {
      storeConsent();
      self.loadMap();
    });
    this.resetBtn.addEventListener('click', function () {
      self.origin = null;
      self.textFilter = '';
      self.queryInput.value = '';
      self.render();
    });
  };

  StoreLocator.prototype.load = function () {
    var self = this;
    fetch(this.apiBase + '/api/public/store-listings', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (body) {
        self.stores = Array.isArray(body) ? body : (body && body.data) || [];
        self.render();
      })
      .catch(function () {
        self.status.textContent = self.t.load_failed;
      });
  };

  StoreLocator.prototype.search = function (query) {
    var self = this;
    if (!query) { this.origin = null; this.textFilter = ''; this.render(); return; }
    var isPostal = /^\d{4,5}$/.test(query);
    var params = isPostal
      ? 'postalCode=' + encodeURIComponent(query) + '&country=' + (query.length === 4 ? 'AT' : 'DE')
      : 'place=' + encodeURIComponent(query);
    this.status.textContent = this.t.loading;
    fetch(this.apiBase + '/api/public/store-listings/geocode?' + params)
      .then(function (res) { return res.ok ? res.json() : null; })
      .catch(function () { return null; })
      .then(function (point) {
        if (point && typeof point.lat === 'number') {
          // Treffer: Händler nach Entfernung zum Suchpunkt sortieren.
          self.textFilter = '';
          self.origin = { lat: point.lat, lng: point.lng, label: query };
          self.render();
        } else if (isPostal) {
          self.origin = null;
          self.status.textContent = self.t.postal_not_found;
        } else {
          // Kein Ort gefunden (oder z. B. ein Geschäftsname): nach Ort/Name filtern.
          self.origin = null;
          self.textFilter = query.toLowerCase();
          self.render();
        }
      });
  };

  StoreLocator.prototype.locate = function () {
    var self = this;
    if (!navigator.geolocation) { this.status.textContent = this.t.locate_failed; return; }
    this.status.textContent = this.t.locating;
    navigator.geolocation.getCurrentPosition(function (pos) {
      self.textFilter = '';
      self.queryInput.value = '';
      self.origin = { lat: pos.coords.latitude, lng: pos.coords.longitude, label: null };
      self.render();
    }, function () {
      self.status.textContent = self.t.locate_failed;
    }, { maximumAge: 600000, timeout: 10000 });
  };

  /** Aktuelle Auswahl: gefiltert und — mit Standort — nach Entfernung sortiert. */
  StoreLocator.prototype.visibleStores = function () {
    var self = this;
    var stores = this.stores.slice();
    if (this.textFilter) {
      stores = stores.filter(function (s) {
        return (s.city + ' ' + s.name + ' ' + s.zip).toLowerCase().indexOf(self.textFilter) !== -1;
      });
    }
    if (this.origin) {
      stores.forEach(function (s) { s._distance = distanceKm(self.origin, s); });
      stores.sort(function (a, b) { return a._distance - b._distance; });
    } else {
      stores.forEach(function (s) { s._distance = null; });
    }
    return stores;
  };

  StoreLocator.prototype.render = function () {
    var t = this.t;
    var stores = this.visibleStores();
    var now = nowInGermany();

    var count = stores.length === 1 ? t.count_one : fill(t.count_other, { count: stores.length });
    if (this.origin) {
      count += ' ' + (this.origin.label ? fill(t.near, { label: this.origin.label }) : t.near_you);
    }
    this.status.textContent = count;
    this.resetBtn.hidden = !(this.origin || this.textFilter);

    this.list.textContent = '';
    if (!stores.length) {
      this.list.appendChild(el('li', 'store-locator__empty', t.no_results || t.no_results_fallback));
    }
    for (var i = 0; i < stores.length; i++) {
      this.list.appendChild(this.card(stores[i], now));
    }
    this.renderMap(stores);
  };

  StoreLocator.prototype.card = function (s, now) {
    var t = this.t;
    var self = this;
    var li = el('li', 'store-card');
    li.id = 'store-' + s.id;
    li.setAttribute('data-store-id', s.id);

    var logoUrl = safeUrl(s.logoUrl);
    if (logoUrl) {
      var img = el('img', 'store-card__logo');
      img.src = logoUrl;
      img.alt = '';
      img.loading = 'lazy';
      img.width = 56;
      img.height = 56;
      li.appendChild(img);
    } else {
      li.appendChild(el('span', 'store-card__logo store-card__logo--empty', (s.name || '?').charAt(0)));
    }

    var body = el('div', 'store-card__body');
    var top = el('div', 'store-card__top');
    top.appendChild(el('h3', 'store-card__name', s.name));
    if (s._distance != null) {
      var km = s._distance < 10 ? s._distance.toFixed(1).replace('.', ',') : String(Math.round(s._distance));
      top.appendChild(el('span', 'store-card__distance', fill(t.distance, { km: km })));
    }
    body.appendChild(top);
    body.appendChild(el('p', 'store-card__address', s.street + ', ' + s.zip + ' ' + s.city));
    if (s.description) body.appendChild(el('p', 'store-card__desc', s.description));

    var status = todayStatus(s.openingHours, now, t);
    body.appendChild(el('p', 'store-card__today store-card__today--' + (status.open ? 'open' : 'closed'), status.text));

    var hasHours = WEEKDAYS.some(function (d) { return s.openingHours && s.openingHours[d] && s.openingHours[d].length; });
    if (hasHours || s.openingHoursNote) {
      var details = el('details', 'store-card__hours');
      details.appendChild(el('summary', null, t.hours));
      if (hasHours) {
        var table = el('table');
        var tbody = el('tbody');
        WEEKDAYS.forEach(function (d) {
          var tr = el('tr', d === now.day ? 'is-today' : null);
          tr.appendChild(el('td', null, t.weekdays[d]));
          tr.appendChild(el('td', null, formatIntervals(s.openingHours[d], t)));
          tbody.appendChild(tr);
        });
        table.appendChild(tbody);
        details.appendChild(table);
      }
      if (s.openingHoursNote) details.appendChild(el('p', 'store-card__note', s.openingHoursNote));
      body.appendChild(details);
    }

    var actions = el('div', 'store-card__actions');
    var route = el('a', null, t.route);
    route.href = 'https://www.google.com/maps/dir/?api=1&destination=' + s.lat + ',' + s.lng;
    route.target = '_blank';
    route.rel = 'noopener nofollow';
    actions.appendChild(route);
    if (s.phone) {
      var tel = el('a', null, s.phone);
      tel.href = 'tel:' + s.phone.replace(/[^\d+]/g, '');
      actions.appendChild(tel);
    }
    var website = safeUrl(s.website);
    if (website) {
      var web = el('a', null, t.website);
      web.href = website;
      web.target = '_blank';
      web.rel = 'noopener nofollow';
      actions.appendChild(web);
    }
    if (this.map) {
      var show = el('button', 'store-card__show', t.show_on_map);
      show.type = 'button';
      show.addEventListener('click', function () { self.focus(s.id, true); });
      actions.appendChild(show);
      // Desktop: Karte steht daneben → Klick auf den Eintrag zeigt ihn dort.
      li.setAttribute('data-map', '');
      li.addEventListener('click', function (e) {
        if (e.target.closest('a, button, summary, details')) return;
        if (!window.matchMedia('(min-width: 990px)').matches) return;
        self.focus(s.id, true);
      });
    }
    body.appendChild(actions);
    li.appendChild(body);
    return li;
  };

  // ---------------------------------------------------------------------------
  // Karte (lazy, nach Zustimmung)
  // ---------------------------------------------------------------------------

  var leafletPromise = null;
  function loadLeaflet(jsUrl, cssUrl) {
    if (window.L) return Promise.resolve(window.L);
    if (leafletPromise) return leafletPromise;
    leafletPromise = new Promise(function (resolve, reject) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = cssUrl;
      document.head.appendChild(link);
      var script = document.createElement('script');
      script.src = jsUrl;
      script.onload = function () { resolve(window.L); };
      script.onerror = reject;
      document.head.appendChild(script);
    });
    return leafletPromise;
  }

  StoreLocator.prototype.loadMap = function () {
    var self = this;
    var consent = this.root.querySelector('[data-store-locator-consent]');
    loadLeaflet(this.root.getAttribute('data-leaflet-js'), this.root.getAttribute('data-leaflet-css'))
      .then(function (L) {
        consent.hidden = true;
        // Mausrad-Zoom nur auf Desktop – mobil würde die Karte sonst das
        // Scrollen der Seite abfangen.
        var desktop = window.matchMedia('(min-width: 990px)');
        self.map = L.map(self.root.querySelector('[data-store-locator-map]'), {
          scrollWheelZoom: desktop.matches
        }).setView([48.1, 11.6], 7);
        var toggleWheel = function () {
          if (desktop.matches) self.map.scrollWheelZoom.enable();
          else self.map.scrollWheelZoom.disable();
        };
        if (desktop.addEventListener) desktop.addEventListener('change', toggleWheel);
        else desktop.addListener(toggleWheel);
        self.map.attributionControl.setPrefix('<a href="https://leafletjs.com">Leaflet</a>');
        L.tileLayer(self.root.getAttribute('data-tile-url'), {
          maxZoom: 18,
          attribution: self.root.getAttribute('data-tile-attribution')
        }).addTo(self.map);
        self.render();
      })
      .catch(function () { consent.hidden = false; });
  };

  StoreLocator.prototype.renderMap = function (stores) {
    if (!this.map) return;
    var L = window.L;
    var self = this;
    if (this.layer) this.layer.remove();
    this.layer = L.layerGroup().addTo(this.map);
    this.markers = {};

    stores.forEach(function (s) {
      var marker = L.marker([s.lat, s.lng], {
        icon: L.divIcon({ className: 'store-marker', iconSize: [18, 18] }),
        title: s.name,
        keyboard: true
      });
      var popup = document.createElement('div');
      popup.appendChild(el('strong', null, s.name));
      popup.appendChild(el('span', null, s.street + ', ' + s.zip + ' ' + s.city));
      marker.bindPopup(popup);
      marker.on('click', function () { self.focus(s.id, false); });
      marker.addTo(self.layer);
      self.markers[s.id] = marker;
    });

    var points = stores.map(function (s) { return [s.lat, s.lng]; });
    if (this.origin) {
      L.marker([this.origin.lat, this.origin.lng], {
        icon: L.divIcon({ className: 'store-marker store-marker--origin', iconSize: [18, 18] }),
        title: this.t.your_location,
        interactive: false
      }).addTo(this.layer);
      // Auf den Suchpunkt zoomen — mit den Händlern im Umkreis (Liste ist
      // bereits nach Entfernung sortiert), weiter entfernte bleiben außen vor.
      var nearby = stores
        .filter(function (s) { return s._distance <= NEARBY_KM; })
        .slice(0, NEARBY_MAX)
        .map(function (s) { return [s.lat, s.lng]; });
      if (!nearby.length) {
        this.map.setView([this.origin.lat, this.origin.lng], ORIGIN_ZOOM);
        return;
      }
      points = [[this.origin.lat, this.origin.lng]].concat(nearby);
    }
    if (points.length === 1) {
      this.map.setView(points[0], 12);
    } else if (points.length > 1) {
      this.map.fitBounds(points, { padding: [40, 40], maxZoom: 13 });
    }
  };

  /** Karte und Liste auf einen Händler ausrichten. */
  StoreLocator.prototype.focus = function (id, fromList) {
    var previous = this.activeId && this.root.querySelector('[data-store-id="' + this.activeId + '"]');
    if (previous) previous.classList.remove('is-active');
    if (this.activeId && this.markers[this.activeId]) {
      var prevIcon = this.markers[this.activeId].getElement();
      if (prevIcon) prevIcon.classList.remove('is-active');
    }
    this.activeId = id;
    var card = this.root.querySelector('[data-store-id="' + id + '"]');
    if (card) {
      card.classList.add('is-active');
      if (!fromList) card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    var marker = this.markers[id];
    if (marker && this.map) {
      var icon = marker.getElement();
      if (icon) icon.classList.add('is-active');
      if (fromList) {
        this.map.setView(marker.getLatLng(), Math.max(this.map.getZoom(), 13));
        marker.openPopup();
        this.root.querySelector('[data-store-locator-map]').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
  };

  function init() {
    document.querySelectorAll('[data-store-locator]').forEach(function (root) {
      if (!root.__storeLocator) root.__storeLocator = new StoreLocator(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Theme-Editor: Section neu gerendert
  document.addEventListener('shopify:section:load', init);
})();
